import React from 'react';

interface CardBrandIconProps {
  brand: string;
  className?: string;
}

export const CardBrandIcon: React.FC<CardBrandIconProps> = ({ brand, className = 'w-10 h-7' }) => {
  const brandLower = brand?.toLowerCase();

  // Visa
  if (brandLower === 'visa') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#1434CB"/>
        <path d="M21.5 21.5L23.8 10.5H26.8L24.5 21.5H21.5Z" fill="white"/>
        <path d="M33.2 10.8C32.7 10.6 31.9 10.4 30.9 10.4C28 10.4 26 11.9 26 14C26 15.5 27.4 16.3 28.5 16.8C29.6 17.3 30 17.6 30 18.1C30 18.8 29.1 19.1 28.3 19.1C27.2 19.1 26.6 18.9 25.7 18.5L25.3 18.3L24.9 20.9C25.5 21.2 26.6 21.4 27.8 21.5C30.9 21.5 32.8 20 32.8 17.8C32.8 16.6 32 15.7 30.3 14.9C29.3 14.4 28.7 14.1 28.7 13.6C28.7 13.1 29.3 12.6 30.5 12.6C31.3 12.6 31.9 12.8 32.4 13L32.7 13.1L33.2 10.8Z" fill="white"/>
        <path d="M37.5 10.5H35.3C34.6 10.5 34.1 10.7 33.8 11.3L29.5 21.5H32.6L33.2 19.9H36.9L37.3 21.5H40L37.5 10.5ZM34 17.5L35.4 13.8L36.2 17.5H34Z" fill="white"/>
        <path d="M18.8 10.5L16 18.8L15.7 17.3C15.2 15.7 13.6 13.9 11.8 13L14.5 21.5H17.7L22.1 10.5H18.8Z" fill="white"/>
        <path d="M13.5 10.5H9.1L9 10.7C12.6 11.6 14.9 13.9 15.7 17.3L14.8 11.4C14.7 10.8 14.2 10.5 13.5 10.5Z" fill="#F7B600"/>
      </svg>
    );
  }

  // Mastercard
  if (brandLower === 'mastercard') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#0B2C5F"/>
        <circle cx="18" cy="16" r="8" fill="#EB001B"/>
        <circle cx="30" cy="16" r="8" fill="#F79E1B"/>
        <path d="M24 9.5C22.3 10.9 21.2 13 21.2 15.4C21.2 17.8 22.3 19.9 24 21.3C25.7 19.9 26.8 17.8 26.8 15.4C26.8 13 25.7 10.9 24 9.5Z" fill="#FF5F00"/>
      </svg>
    );
  }

  // American Express
  if (brandLower === 'amex' || brandLower === 'american express') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#006FCF"/>
        <path d="M11.5 13.5L10 17H13L11.5 13.5Z" fill="white"/>
        <path d="M8 11H13.5L14.5 13L15.5 11H21V12.5L21.8 11H26L27.8 14.8L29.6 11H40V20H34.5L33.5 19L32.5 20H16L15.3 18.5H13.7L13 20H10V16L8.5 20H5.5L3 11H6.5L8 15.5V11ZM10 12.5L7.5 19H9L9.5 17.5H13.5L14 19H16.5V13L18.5 19H20L22 13V19H24V12.5H21L19.2 17.5L17.5 12.5H14.5V17L12.5 12.5H10ZM26 12.5V14H29.5V15.5H26V17H29.5V18.5H26V19H30.5L32 17.5L33.5 19H38V17H35.5V15.5H38V14H35.5V12.5H38V11H33L31.5 12.5L30 11H26V12.5Z" fill="white"/>
      </svg>
    );
  }

  // Elo
  if (brandLower === 'elo') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#000000"/>
        <path d="M14 11C11.8 11 10 12.8 10 15C10 17.2 11.8 19 14 19C14.9 19 15.7 18.7 16.4 18.2L15.2 16.5C14.9 16.8 14.5 17 14 17C12.9 17 12 16.1 12 15C12 13.9 12.9 13 14 13C14.5 13 14.9 13.2 15.2 13.5L16.4 11.8C15.7 11.3 14.9 11 14 11Z" fill="#FFCB05"/>
        <path d="M17 15C17 12.8 18.8 11 21 11C23.2 11 25 12.8 25 15C25 17.2 23.2 19 21 19C18.8 19 17 17.2 17 15ZM19 15C19 16.1 19.9 17 21 17C22.1 17 23 16.1 23 15C23 13.9 22.1 13 21 13C19.9 13 19 13.9 19 15Z" fill="#00A4E0"/>
        <path d="M26 11H28V17H32V19H26V11Z" fill="#EF4123"/>
      </svg>
    );
  }

  // Diners Club
  if (brandLower === 'diners' || brandLower === 'diners club') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#0079BE"/>
        <circle cx="18" cy="16" r="6" fill="white"/>
        <circle cx="30" cy="16" r="6" fill="white"/>
        <path d="M18 13C16.3 13 15 14.3 15 16C15 17.7 16.3 19 18 19V13Z" fill="#0079BE"/>
        <path d="M30 13V19C31.7 19 33 17.7 33 16C33 14.3 31.7 13 30 13Z" fill="#0079BE"/>
      </svg>
    );
  }

  // Discover
  if (brandLower === 'discover') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#FF6000"/>
        <path d="M38 16C38 20.4 34.4 24 30 24H18C13.6 24 10 20.4 10 16V8H38V16Z" fill="#231F20"/>
        <circle cx="40" cy="24" r="12" fill="#F48120"/>
      </svg>
    );
  }

  // JCB
  if (brandLower === 'jcb') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="white"/>
        <rect x="4" y="8" width="12" height="16" rx="2" fill="#0E4C96"/>
        <rect x="18" y="8" width="12" height="16" rx="2" fill="#D2232A"/>
        <rect x="32" y="8" width="12" height="16" rx="2" fill="#009639"/>
      </svg>
    );
  }

  // Hipercard
  if (brandLower === 'hipercard') {
    return (
      <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#A02324"/>
        <path d="M12 12H16V20H12V12ZM18 12H22V20H18V12ZM26 12H36V14H26V12ZM26 15H36V17H26V15ZM26 18H36V20H26V18Z" fill="white"/>
      </svg>
    );
  }

  // Default/Unknown card
  return (
    <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="4" fill="#6B7280"/>
      <rect x="8" y="10" width="32" height="4" rx="1" fill="white" opacity="0.6"/>
      <rect x="8" y="18" width="20" height="2" rx="1" fill="white" opacity="0.4"/>
      <rect x="30" y="18" width="10" height="2" rx="1" fill="white" opacity="0.4"/>
    </svg>
  );
};
